export function useMapShipperContact(contact, modelValue) {

    modelValue.shipper.shipperContactId = contact.id;
    modelValue.shipper.shipperContactTitle = contact.title;
    modelValue.shipper.shipperContactFirstName = contact.firstName;
    modelValue.shipper.shipperContactLastName = contact.lastName;
    modelValue.shipper.shipperContactPhone = contact.phone;
    modelValue.shipper.shipperContactEmail = contact.email;
    modelValue.shipper.shipperContactDepartment = contact.department;
    modelValue.shipper.shipperContactFullName = contact.value;
}
